import { Form } from 'antd';
import React, { useContext } from 'react';

import { COUNT_RECORD_QUERY } from '../../const';
import { ScheduleItemConnectionFragment } from '../../graphql/fragments/ScheduleItemConnectionFragment';
import { ScheduleItemFragment } from '../../graphql/fragments/ScheduleItemFragment';
import { ScheduleItemListFragment } from '../../graphql/fragments/ScheduleItemListFragment';
import { accessCheck, DynamicList, ScheduleItemsQuery, SmxPermissionContext } from '../../index';
import { IFieldListBase } from '../../interfaces';
import { ItemType, ScheduleItemType } from '../../types';

const FieldParent: React.FC<IFieldListBase> = ({ disabled, filterFlexible }) => {
    const { userId, permissionListScore } = useContext(SmxPermissionContext);

    return (
        <Form.Item<ItemType>
            label="Main Item"
            name="parentId"
            rules={[{ required: true, message: 'Please select item!' }]}
        >
            <DynamicList
                query={ScheduleItemsQuery}
                fragmentList={ScheduleItemListFragment}
                fragmentConnection={ScheduleItemConnectionFragment}
                fragment={ScheduleItemFragment}
                nameQuery={'scheduleItems'}
                fields={['name'] as (keyof ScheduleItemType)[]}
                template={'name'}
                countRecord={COUNT_RECORD_QUERY}
                disabled={disabled}
                allowClear={false}
                // localFilters={localFilters}
                filterFlexible={filterFlexible}
                checkAccessPermission={(item: ScheduleItemType) => {
                    const isOwner = item?.owner_item_id === userId;
                    const isAssignee = item?.assignee?.includes(userId);
                    return accessCheck(
                        permissionListScore,
                        [
                            'work-item.all.create',
                            'work-item.all.edit',
                            'work-item.all.manage',
                            'work-item.owner.create',
                            'work-item.owner.edit',
                            'work-item.owner.manage',
                            'work-item.assignee.create',
                            'work-item.assignee.edit',
                            'work-item.assignee.manage',
                        ],
                        isOwner,
                        isAssignee,
                    );
                }}
            />
        </Form.Item>
    );
};

export default React.memo(FieldParent);
